module.exports = __webpack_public_path__ + "static/media/empty-cart.05d8cea1.gif";